import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';

// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<

// Subscription system for interaction ID changes

var listeners = new Set();

// Observable interaction ID implementation
var ObservableInteractionID = /*#__PURE__*/function () {
  function ObservableInteractionID() {
    _classCallCheck(this, ObservableInteractionID);
    _defineProperty(this, "_current", null);
  }
  return _createClass(ObservableInteractionID, [{
    key: "current",
    get: function get() {
      return this._current;
    },
    set: function set(newId) {
      var oldId = this._current;
      this._current = newId;

      // Notify all listeners if the ID actually changed and feature flag is enabled
      if (oldId !== newId && fg('platform_ufo_hold_cross_interaction')) {
        listeners.forEach(function (listener) {
          return listener(newId);
        });
      }
    }
  }]);
}(); // Type declaration for globalThis extension
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
var initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
  // Return existing instance if already initialized
  if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) {
    return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
  }

  // Create and store new instance globally
  var instance = new ObservableInteractionID();
  globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
  return instance;
};

// The default InteractionID object is a global singleton stored in globalThis.
// It holds the root value used in routing and is updated when new interactions start.
export var DefaultInteractionID = initializeGlobalDefaultInteractionID();

// Subscription functions
export var subscribeToInteractionIdChanges = function subscribeToInteractionIdChanges(listener) {
  if (!fg('platform_ufo_hold_cross_interaction')) {
    // Return a no-op unsubscribe function when feature flag is disabled
    return function () {};
  }
  listeners.add(listener);
  return function () {
    listeners.delete(listener);
  };
};

// We use a context to allow modals to have their own lifecycle
export default /*#__PURE__*/createContext(DefaultInteractionID);
export var getInteractionId = function getInteractionId() {
  return DefaultInteractionID;
};
export var useInteractionId = function useInteractionId() {
  return DefaultInteractionID;
};